import { GameSystems } from "./gameSystems";
import { SpecialRuleType } from "./rules";

export * from "./_migrate";
export * from "./armies";
export * from "./balval";
export * from "./campaign";
export * from "./changelog";
export * from "./cms";
export * from "./gameSystems";
export * from "./quest";
export * from "./rangers";
export * from "./reports";
export * from "./rules";
export * from "./saveData";
export * from "./spells";
export * from "./units";
export * from "./upgrades";
export * from "./users";
export * from "./warfleets";
export * from "./weapons";

export enum AsyncStatus {
  idle,
  loading,
  succeeded,
  failed
}

export interface IGameRule {
  id: number;
  name: string;
  description: string;
  aliasedRuleId?: number;
  gameSystem: GameSystems;
  ruleType?: SpecialRuleType;
  hasRating?: boolean;
}

export interface IPartnerData {
  userId: string;
  username: string;
  creator: "creator:verified" | "creator:star" | "creator:partner";
  bannerImage: string;
  logoImage: string;
  intro: string;
  links: any;
  imageLinks: any;
}

export type SortOptions = "alpha" | "votes_month" | "votes" | "units" | "modified";

export interface IViewPreferences {
  showFullRules: boolean;
  showPointCosts: boolean;
  combineSameUnits: boolean;
  showPsychic: boolean;
  showCommon: boolean;
  removeProduct: boolean;
}

export type ImageFolder =
  | "cover"
  | "banner"
  | "army"
  | "partnerBanner"
  | "partnerLogo"
  | "partnerImage"
  | "unitProduct"
  | "cms";

export enum ReportReason {
  Copyright,
  Offensive
}

export type Success<T> = [T, null];
export type Failure<E> = [null, E];
export type ServerResult<T, E = Error> = Success<T> | Failure<E>;

export interface IBookmark {
  uid: string;
  ftl: boolean;
  flavouredUid: string;
  gameSystem: number;
  name: string;
  enabledGameSystems: GameSystems[];
  factionName?: string;
  factionRelation?: string;
  coverImagePath: string;
  unitCount: number;
  official: boolean;
  username?: string;
  modifiedAt: string;
  isCreator: boolean;
  popularity: number;
  created: string;
}

export enum AuthPromptType {
  Like,
  Bookmark,
  Report
}
